var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 5.1416C15.8 6.29993 16.95 8.1416 17.1833 10.2666",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90845 10.3086C3.12511 8.19193 4.25845 6.35026 5.90845 5.18359",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82495 17.4502C7.79162 17.9419 8.89162 18.2169 10.05 18.2169C11.1666 18.2169 12.2166 17.9669 13.1583 17.5085",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0501 6.41654C11.3295 6.41654 12.3667 5.37933 12.3667 4.09987C12.3667 2.82041 11.3295 1.7832 10.0501 1.7832C8.77061 1.7832 7.7334 2.82041 7.7334 4.09987C7.7334 5.37933 8.77061 6.41654 10.0501 6.41654Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02492 16.6001C5.30438 16.6001 6.34159 15.5629 6.34159 14.2835C6.34159 13.004 5.30438 11.9668 4.02492 11.9668C2.74546 11.9668 1.70825 13.004 1.70825 14.2835C1.70825 15.5629 2.74546 16.6001 4.02492 16.6001Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9751 16.6001C17.2546 16.6001 18.2918 15.5629 18.2918 14.2835C18.2918 13.004 17.2546 11.9668 15.9751 11.9668C14.6957 11.9668 13.6584 13.004 13.6584 14.2835C13.6584 15.5629 14.6957 16.6001 15.9751 16.6001Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.50e9068cec2fcd4c5bca29f710a66f9c.svg";
export { ForwardRef as ReactComponent };